
<!-- Limitation: Ne peut être un Area. Doit être un component -->
<!-- Cause: on ne connait pas le parentTemplateId -->
<div v-if="contentHerite || contentHeritage" :class="jel_getClassObject(content)">
  <component
    :is="nomComponent(metadataHerite)"
    v-if="contentHerite"
    :key="metadataHerite['@id']"
    :metadata="metadataHerite"
    :content="contentHerite"
  />
  <div v-else-if="contentHeritage">
    <div v-for="component in contentHeritage['@nodes']" :key="component['@id']">
      <component
        :is="nomComponent(getComponentMetadata(contentHeritage[component]))"
        :metadata="getComponentMetadata(contentHeritage[component])"
        :content="getComponentContent(contentHeritage[component])"
      />
    </div>
  </div>
</div>
